import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type ChatMessageSendingJobNewPageQuotaFragment = { __typename?: 'Query', lineMessagingCurrentMonthQuota: { __typename?: 'LineMessagingCurrentMonthQuotaPayload', totalUsage: number, quota: { __typename?: 'LineMessagingCurrentMonthQuota_Limited', limit: number } | { __typename?: 'LineMessagingCurrentMonthQuota_None', void: any } } };

export const ChatMessageSendingJobNewPageQuotaFragmentDoc = gql`
    fragment ChatMessageSendingJobNewPageQuota on Query {
  lineMessagingCurrentMonthQuota {
    quota {
      ... on LineMessagingCurrentMonthQuota_None {
        void
      }
      ... on LineMessagingCurrentMonthQuota_Limited {
        limit
      }
    }
    totalUsage
  }
}
    `;